import {Component, ElementRef, Input, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {UserSettingsService} from '../user-settings.service';
import {Subscription} from 'rxjs';
import {User} from 'src/app/models/user.model';
import {UserGroup} from 'src/app/models/user-group.model';
import {AppService} from 'src/app/app.service';
import {Constants} from 'src/app/shared/utils/constants';
import {Permission} from 'src/app/models/permission.model';
import {NgForm} from '@angular/forms';

@Component({
  selector: 'fx-user',
  templateUrl: './user.component.html',
  styleUrls: ['./user.component.sass']
})
export class UserComponent implements OnInit, OnDestroy {
  @Input() groups: UserGroup[];
  @Input() permission: Permission;
  @ViewChild('form', { static: false }) form: NgForm;
  showError = false;
  pageInfo: any = {
    pageSize: 10,
    pageIndex: 1,
    totalRecord: 0
  };
  subscription = {
    getUsers: new Subscription(),
    createUser: new Subscription(),
    updateUser: new Subscription(),
    deleteUser: new Subscription()
  };
  permissionColors = ['#6d7278', '#44d7b6;', '', '#f7b500'];
  users: User[];
  user: User = new User();
  @ViewChild('modalUser', { static: false }) modalUser: ElementRef;
  selectedGroup: UserGroup = new UserGroup();
  manageUserMode: string;
  constructor(
    private appService: AppService,
    private userSettingsService: UserSettingsService
  ) {
    this.user = new User();
    this.getUsers();
  }

  ngOnInit(): void {}

  getUsers(): any {
    return (this.subscription.getUsers = this.userSettingsService
      .getUsers()
      .subscribe(data => {
        if (data.status === Constants.RESPONSE_STATUS.SUCCESS) {
          this.users = data.data;
        }
      }));
  }

  createUser(user: User): any {
    this.subscription.createUser = this.userSettingsService
      .create(user)
      .subscribe(data => {
        if (data.status === Constants.RESPONSE_STATUS.SUCCESS) {
          this.showError = false;
          this.appService.showSuccess('Create User Successful!');
          this.getUsers();
          this.modalUser.nativeElement.querySelector('button.close').click();
        } else {
          this.appService.showError(data.message || 'Create User Failed!');
        }
      });
  }

  updateUser(user: User): void {
    this.subscription.updateUser = this.userSettingsService
      .update(user)
      .subscribe(data => {
        if (data.status === Constants.RESPONSE_STATUS.SUCCESS) {
          this.appService.showSuccess('Update User Successful!');
          this.getUsers();
          this.modalUser.nativeElement.querySelector('button.close').click();
        } else {
          this.appService.showError(data.message || 'Update User Failed!');
        }
      });
  }

  deleteUser(i: number, user: User): void {
    if (confirm('Are you sure that you want to delete this user?')) {
      this.subscription.deleteUser = this.userSettingsService
        .delete([user.id])
        .subscribe(data => {
          if (data.status === Constants.RESPONSE_STATUS.SUCCESS) {
            this.showError = false;
            this.appService.showSuccess('Delete User Successful!');
            this.getUsers();
            this.modalUser.nativeElement.querySelector('button.close').click();
          } else {
            this.appService.showError(data.message || 'Delete User Failed!');
          }
        });
    }
  }

  onPageChange(evt): void {
    this.pageInfo.pageIndex = evt;
  }

  addUser(): void {
    this.manageUserMode = 'Add';
    this.user = new User();
  }

  editUser(i: number, user: User): void {
    this.manageUserMode = 'Edit';
    user.confirmPassword = user.password;
    this.user = user;
  }

  save(): any {
    this.showError = true;
    if (
      this.form.valid &&
      ((this.manageUserMode === 'Add' &&
        this.user.password === this.user.confirmPassword) ||
        this.manageUserMode === 'Edit')
    ) {
      const data = this.user;
      delete data.confirmPassword;
      if (this.manageUserMode === 'Add') {
        this.createUser(data);
      } else {
        this.updateUser(data);
      }
    }
    return null;
  }

  ngOnDestroy(): void {
    for (const key in this.subscription) {
      if (this.subscription.hasOwnProperty(key)) {
        this.subscription[key].unsubscribe();
      }
    }
  }

  getUserGroups(user: User): string {
    const group = this.groups
      ? this.groups.find(g => g.id === user.groupId)
      : new UserGroup();
    return group ? group.name : '';
  }
}
